import React from 'react';
import PropTypes from 'prop-types';

import Input from "core/gd-form/form-element/input/input";
import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";

export default function CustomFieldName(props) {

    return (
        <FormRow label="Name">
            <Input size="big" form={props.form} name="name"/>
            <FormError form={props.form} name="name" />
        </FormRow>
    );
}

CustomFieldName.propTypes = {
    form: PropTypes.object
}